import { render, staticRenderFns } from "./send.vue?vue&type=template&id=27e8e706&"
import script from "./send.vue?vue&type=script&lang=js&"
export * from "./send.vue?vue&type=script&lang=js&"
import style0 from "./send.vue?vue&type=style&index=0&id=27e8e706&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports